import { render, staticRenderFns } from "./UploadOptions.vue?vue&type=template&id=bdaa865e&"
import script from "./UploadOptions.vue?vue&type=script&lang=js&"
export * from "./UploadOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports